import React, { useEffect } from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { autorun } from 'mobx';
import { getWindowInnerWidth, getWindowInnerHeight } from 'src_common/common/mobx-utils/Services/window';
import { BetslipSelection } from 'src/domains/sportsbook/betting/ui/betSlip/betslipSelection/BetslipSelection';
import { CustomKeyboard } from 'src/domains/sportsbook/betting/ui/betSlip/customKeyboard/CustomKeyboard';
import {
    QuickBetContainer,
    QuickBetWrapper,
    SelectionWrapper,
    LoginWrapper,
    QuickBetSuccessWrapper,
    CheckMarkWrapper,
    QuickBetHeader,
    QuickBetCloseButton,
    QuickBetErrorsAndWarningsWrapper,
} from './QuickBet.style';
import { BetSlipButtons } from 'src/domains/sportsbook/betting/ui/betSlip/betSlipButtons/BetSlipButtons';
import { observer } from 'src/utils/mobx-react';
import {
    LogInToPlaceBet,
    PayoutRules,
} from 'src/domains/sportsbook/betting/ui/betSlip/betSlipButtons/BetslipButtonsElements';
import { useAppStateContext } from 'src/appState/AppState';
import { useCommon } from 'src/domains/common/Common';
import { AlertBannerInline } from 'src/domains/layouts/webview/components/alertBanner/Inline';
import { ErrorsAndWarnings } from '../errorAndWarningMessages/ErrorsAndWarnings';

export const QuickBet = observer('QuickBet', (): JSX.Element => {
    const { appSportsBookState } = useAppStateContext();
    const { betSlipState } = appSportsBookState;
    const { basicBetSlipState, firstSelection2, betSlipSummaryState, quickBetState } = betSlipState;

    useEffect(() => {
        const dispose = autorun(() => {
            const { isShowQuickBet, onCloseQuickBet } = basicBetSlipState;

            const innerWidth = getWindowInnerWidth();
            const innerHeight = getWindowInnerHeight();

            if (
                isShowQuickBet &&
                innerWidth !== null &&
                innerHeight !== null &&
                (innerWidth > innerHeight || innerWidth >= 1024)
            ) {
                onCloseQuickBet();
            }
        });
        return (): void => {
            dispose();
        };
    }, []);

    const common = useCommon();
    const { session } = common;

    const { isVisibleQuickBet } = quickBetState;
    const { betReceipt } = betSlipSummaryState;

    return (
        <>
            <QuickBetContainer
                isVisible={isVisibleQuickBet && firstSelection2 !== null}
                data-test='quick-bet-container'
            >
                {isVisibleQuickBet && firstSelection2 !== null && (
                    <QuickBetWrapper>
                        <QuickBetHeader data-test='quick-bet-header'>
                            <I18n
                                langKey='bets.quick-bet.header'
                                defaultText='Quick Bet'
                            />
                            <QuickBetCloseButton onClick={basicBetSlipState.onCloseQuickBet} />
                        </QuickBetHeader>

                        <SelectionWrapper>
                            <BetslipSelection id={firstSelection2} />
                            {session.isAuthorized === false ? (
                                <LoginWrapper>
                                    <LogInToPlaceBet />
                                    <AlertBannerInline
                                        marginBottom='16px'
                                        marginTop='8px'
                                        message={<PayoutRules />}
                                        size='small'
                                    />
                                </LoginWrapper>
                            ) : null}
                        </SelectionWrapper>

                        {session.isAuthorized && (
                            <>
                                <QuickBetErrorsAndWarningsWrapper>
                                    <ErrorsAndWarnings />
                                </QuickBetErrorsAndWarningsWrapper>
                                <BetSlipButtons />
                            </>
                        )}

                        <CustomKeyboard isQuickBet={true} />
                    </QuickBetWrapper>
                )}
            </QuickBetContainer>

            {betReceipt !== null && isVisibleQuickBet && (
                <QuickBetSuccessWrapper data-test='quick-bet-success-message'>
                    <CheckMarkWrapper />
                    <I18n
                        langKey='bets.quick-bet.placed-successfully'
                        defaultText='Bet placed successfully!'
                    />
                </QuickBetSuccessWrapper>
            )}
        </>
    );
});
